
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { JSONFormData } from '../../models/form-data';
import { FormDataService } from './form-data.service';

@Injectable()
export class FormDataResolver implements Resolve<JSONFormData> {

  constructor(private formDataService: FormDataService,
    private router: Router) { }

  resolve(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<JSONFormData> {
    const id = +route.params['id'];
    const type = route.params['type'];
    const form = route.params['form'];

    if (isNaN(+id)) {
      this.router.navigate(['/courses']);
      return observableOf(null);
    }
    return this.formDataService.getFormData(+id).pipe(
      map(formDataResponse => {
        if (formDataResponse) {
          if (id === 0) {
            formDataResponse.formData.type = type || 'course';
            formDataResponse.formData.form_id = form || 0;
          }
          return formDataResponse.formData;
        }

        this.router.navigate(['/courses']);

        return null;
      }),
      catchError(error => {
        console.error(`Retrieval error: ${error}`);
        this.router.navigate(['/courses']);
        return observableOf(null);
      }));
  }
}
